import { render, staticRenderFns } from "./singleTemplate.vue?vue&type=template&id=79191616&scoped=true&"
import script from "./singleTemplate.vue?vue&type=script&lang=js&"
export * from "./singleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./singleTemplate.vue?vue&type=style&index=0&id=79191616&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79191616",
  null
  
)

export default component.exports